import { useEffect, useState } from "react";
import { Plus, Trash2, Check, ShoppingBasket } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ShoppingPage() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [qty, setQty] = useState("");

  const refresh = async () => {
    const { data } = await api.get("/shopping");
    setItems(data);
  };

  useEffect(() => { refresh(); }, []);

  const add = async (e) => {
    e?.preventDefault();
    if (!name.trim()) return;
    await api.post("/shopping", { name: name.trim(), quantity: qty });
    setName(""); setQty("");
    refresh();
  };

  const toggle = async (id) => {
    await api.patch(`/shopping/${id}`);
    refresh();
  };

  const remove = async (id) => {
    await api.delete(`/shopping/${id}`);
    refresh();
  };

  const clearDone = async () => {
    const done = items.filter(i => i.done);
    for (const it of done) await api.delete(`/shopping/${it.id}`);
    toast.success("Voci completate eliminate");
    refresh();
  };

  const pending = items.filter(i => !i.done);
  const done = items.filter(i => i.done);

  return (
    <div className="px-5 md:px-10 py-8 max-w-3xl mx-auto">
      <p className="text-xs uppercase tracking-widest text-tertiary-fg font-semibold">Famiglia</p>
      <h1 className="font-display text-3xl font-semibold tracking-tight mt-1 mb-6 flex items-center gap-2">
        <ShoppingBasket className="w-7 h-7 text-sage" /> Lista Spesa
      </h1>

      <form onSubmit={add} className="bg-surface border border-subtle rounded-3xl p-4 flex gap-2">
        <input
          data-testid="shopping-name-input"
          className="input-warm flex-1"
          placeholder="Es. Latte, pane, mele..."
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          data-testid="shopping-qty-input"
          className="input-warm w-24"
          placeholder="2x"
          value={qty}
          onChange={(e) => setQty(e.target.value)}
        />
        <button type="submit" data-testid="shopping-add-button" className="btn-primary !px-4">
          <Plus className="w-4 h-4" />
        </button>
      </form>

      <div className="mt-6">
        <div className="text-xs uppercase tracking-widest text-tertiary-fg font-semibold mb-3">Da comprare ({pending.length})</div>
        <div className="space-y-2">
          {pending.map(it => (
            <div key={it.id} data-testid={`shopping-item-${it.id}`} className="bg-surface border border-subtle rounded-2xl p-3 flex items-center gap-3 animate-fade-up">
              <button
                onClick={() => toggle(it.id)}
                data-testid={`shopping-toggle-${it.id}`}
                className="w-6 h-6 rounded-full border-2 border-subtle hover:border-brand grid place-items-center"
              >
              </button>
              <div className="flex-1">
                <div className="text-sm font-medium">{it.name}</div>
                <div className="text-xs text-tertiary-fg">{it.quantity} · da {it.added_by}</div>
              </div>
              <button onClick={() => remove(it.id)} className="p-2 rounded-full hover:bg-elevated text-rose-warm">
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
          {pending.length === 0 && <div className="text-center text-tertiary-fg py-8 text-sm">Lista vuota.</div>}
        </div>
      </div>

      {done.length > 0 && (
        <div className="mt-8">
          <div className="flex items-center justify-between mb-3">
            <div className="text-xs uppercase tracking-widest text-tertiary-fg font-semibold">Completati ({done.length})</div>
            <button onClick={clearDone} data-testid="shopping-clear-done" className="text-xs text-rose-warm hover:underline">Svuota</button>
          </div>
          <div className="space-y-2">
            {done.map(it => (
              <div key={it.id} className="bg-surface/50 border border-subtle rounded-2xl p-3 flex items-center gap-3 opacity-60">
                <button onClick={() => toggle(it.id)} className="w-6 h-6 rounded-full bg-sage grid place-items-center">
                  <Check className="w-3 h-3 text-white" />
                </button>
                <div className="flex-1 text-sm line-through text-tertiary-fg">{it.name} {it.quantity}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
